export const testIDs = {
	STANDARD_DIALOGUE: 'standard-dialogue',
	HOME_BUTTON: 'home-button',
};
